import crud from '@/crud/index/index'

import components from './components'
import computed from './computed'
import data from './data'
import methods from './methods'

export default {
  components,
  computed,
  data,
  methods,

  mixins: [crud],

  resourcePath: 'v1/search/families/search'
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/family/resources/index.js